module.exports = __webpack_public_path__ + "img/arrow_down.73722163.png";